// extracted by mini-css-extract-plugin
module.exports = {"row":"TimeCounter-styles-row-18ikaR7m","timer":"TimeCounter-styles-timer-3zPaBFbc","square":"TimeCounter-styles-square-1NTpvSaf"};